<section class="overflow-hidden bg-gray3 text-primary width-800 pb-20">
  <div class="row">
    <div
      class="col-6 col-md-6 p-10 text-center rounded-top-left cursor-pointer"
      [class.secondary]="current == 'login'"
      (click)="tab('signUp')"
    >
      <div
        class="size-8 weight-700 border-0 text-primary"
        [class.text-white]="current == 'login'"
      >
        {{ "account.createAccount" | translate }}
      </div>
    </div>
    <div
      class="col-6 col-md-6 p-10 text-center rounded-top-right cursor-pointer"
      [class.secondary]="current == 'signUp'"
      (click)="tab('login')"
    >
      <div
        class="size-8 weight-700 border-0 text-primary"
        [class.text-white]="current != 'login'"
      >
        {{ "account.logIn" | translate }}
      </div>
    </div>
  </div>
  <div>
    <app-register
      [hidden]="current == 'login'"
      (changeSignUp)="tab($event)"
    ></app-register>
    <app-login
      [hidden]="current == 'signUp'"
      (changeLogin)="tab($event)"
    ></app-login>
    <div class="mrt-20">
      <img
        class="pattern-line"
        src="../../../../assets/images/pattern.svg"
        alt="line"
      />
    </div>
  </div>
</section>
